import { ConversionTracker } from 'api-clients/monolith/models/ConversionTracker';
import React from 'react';

import { ConversionTracking } from 'components/conversionTracking';

export interface TrackingPixel {
  provider: string;
  trackingPixel: string;
  customJavascript?: string;
  variables?: Record<string, unknown>;
}

interface TrackingPixelsProps {
  pixels: TrackingPixel[] | undefined;
}

export function TrackingPixels({ pixels }: TrackingPixelsProps) {
  if (!pixels || pixels.length === 0) {
    return null;
  }

  return (
    <>
      {pixels.map((pixel, index) => {
        const tracker: ConversionTracker = {
          id: index,
          name: `${pixel.provider}-${index}`,
          provider: pixel.provider,
          tracking_pixel: pixel.trackingPixel,
          custom_javascript: pixel.customJavascript,
          variables: (pixel.variables as Record<string, string>) || {},
        };

        return (
          <ConversionTracking
            key={`${pixel.provider}-${pixel.trackingPixel}`}
            tracker={tracker}
          />
        );
      })}
    </>
  );
}
